// O favicon padrao tem uma variante com badge para mensagens nao lidas. Quando a
// instalacao usa logo propria (LOGO_THUMBNAIL customizado) essa variante nao
// existe, entao o icone fica como esta em vez de virar o do Chatwoot.
const hasCustomFavicon = () =>
  Boolean(document.querySelector('link.favicon[data-custom-favicon]'));

export const showBadgeOnFavicon = () => {
  if (hasCustomFavicon()) return;
  const favicons = document.querySelectorAll('.favicon');

  favicons.forEach(favicon => {
    const newFileName = `/favicon-badge-${favicon.sizes[[0]]}.png`;
    favicon.href = newFileName;
  });
};

export const initFaviconSwitcher = () => {
  if (hasCustomFavicon()) return;
  const favicons = document.querySelectorAll('.favicon');

  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      favicons.forEach(favicon => {
        const oldFileName = `/favicon-${favicon.sizes[[0]]}.png`;
        favicon.href = oldFileName;
      });
    }
  });
};
